import React from "react"
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "src/components/ui/table"

export default function ConversionTable({ stages = [] }) {
  if (!stages.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 text-[13px] font-medium text-slate-700">Stage Conversion</div>
      <Table className="text-[13px]">
        <TableHeader className="bg-slate-50 text-left text-slate-500">
          <TableRow className="hover:bg-transparent">
            <TableHead className="h-9 font-medium text-slate-500">Stage</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Reached</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Converted</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Rate</TableHead>
            <TableHead className="h-9 text-right font-medium text-slate-500">Avg Days</TableHead>
            <TableHead className="h-9 w-32 font-medium text-slate-500">Progress</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {stages.map((s) => (
            <TableRow key={s.stage_id}>
              <TableCell className="py-2.5 font-medium text-slate-900">{s.name}</TableCell>
              <TableCell className="py-2.5 text-right">{s.reached}</TableCell>
              <TableCell className="py-2.5 text-right">{s.converted_to_next ?? "—"}</TableCell>
              <TableCell className="py-2.5 text-right">
                {s.conversion_rate != null ? `${s.conversion_rate}%` : "—"}
              </TableCell>
              <TableCell className="py-2.5 text-right">
                {s.avg_days_in_stage != null ? `${s.avg_days_in_stage}d` : "—"}
              </TableCell>
              <TableCell className="py-2.5">
                {s.conversion_rate != null && (
                  <div className="h-2 w-full rounded-full bg-slate-100">
                    <div
                      className="h-2 rounded-full bg-indigo-500"
                      style={{ width: `${Math.min(s.conversion_rate, 100)}%` }}
                    />
                  </div>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
